const ISO_639_1_LANGUAGES = [
  { code: 'aa', nativeName: 'Qafár af', name: 'Afar' },
  { code: 'ab', nativeName: 'Аҧсшәа', name: 'Abkhazian' },
  { code: 'ae', nativeName: 'Avesta', name: 'Avestan' },
  { code: 'af', nativeName: 'Afrikaans', name: 'Afrikaans' },
  { code: 'ak', nativeName: 'Akan', name: 'Akan' },
  { code: 'am', nativeName: 'አማርኛ', name: 'Amharic' },
  { code: 'an', nativeName: 'Aragonés', name: 'Aragonese' },
  { code: 'ar', nativeName: 'العربية', name: 'Arabic' },
  { code: 'as', nativeName: 'অসমীয়া', name: 'Assamese' },
  { code: 'av', nativeName: 'Авар мацӏ', name: 'Avaric' },
  { code: 'ay', nativeName: 'Aymar aru', name: 'Aymara' },
  { code: 'az', nativeName: 'Azərbaycan dili', name: 'Azerbaijani' },
  { code: 'ba', nativeName: 'Башҡорт теле', name: 'Bashkir' },
  { code: 'be', nativeName: 'Беларуская мова', name: 'Belarusian' },
  { code: 'bg', nativeName: 'Български', name: 'Bulgarian' },
  { code: 'bh', nativeName: 'भोजपुरी', name: 'Bihari' },
  { code: 'bi', nativeName: 'Bislama', name: 'Bislama' },
  { code: 'bm', nativeName: 'Bamanankan', name: 'Bambara' },
  { code: 'bn', nativeName: 'বাংলা', name: 'Bengali' },
  { code: 'bo', nativeName: 'བོད་ཡིག', name: 'Tibetan' },
  { code: 'br', nativeName: 'Brezhoneg', name: 'Breton' },
  { code: 'bs', nativeName: 'Bosanski', name: 'Bosnian' },
  { code: 'ca', nativeName: 'Català', name: 'Catalan' },
  { code: 'ce', nativeName: 'Нохчийн мотт', name: 'Chechen' },
  { code: 'ch', nativeName: 'Chamoru', name: 'Chamorro' },
  { code: 'co', nativeName: 'Corsu', name: 'Corsican' },
  { code: 'cr', nativeName: 'ᓀᐦᐃᔭᐍᐏᐣ', name: 'Cree' },
  { code: 'cs', nativeName: 'Čeština', name: 'Czech' },
  { code: 'cu', nativeName: 'Ѩзыкъ словѣньскъ', name: 'Church Slavic' },
  { code: 'cv', nativeName: 'Чӑваш чӗлхи', name: 'Chuvash' },
  { code: 'cy', nativeName: 'Cymraeg', name: 'Welsh' },
  { code: 'da', nativeName: 'Dansk', name: 'Danish' },
  { code: 'de', nativeName: 'Deutsch', name: 'German' },
  { code: 'dv', nativeName: 'ދިވެހި', name: 'Divehi' },
  { code: 'dz', nativeName: 'རྫོང་ཁ', name: 'Dzongkha' },
  { code: 'ee', nativeName: 'Eʋegbe', name: 'Ewe' },
  { code: 'el', nativeName: 'Ελληνικά', name: 'Greek' },
  { code: 'en', nativeName: 'English', name: 'English' },
  { code: 'eo', nativeName: 'Esperanto', name: 'Esperanto' },
  { code: 'es', nativeName: 'Español', name: 'Spanish' },
  { code: 'et', nativeName: 'Eesti', name: 'Estonian' },
  { code: 'eu', nativeName: 'Euskara', name: 'Basque' },
  { code: 'fa', nativeName: 'فارسی', name: 'Persian' },
  { code: 'ff', nativeName: 'Fulfulde', name: 'Fulah' },
  { code: 'fi', nativeName: 'Suomi', name: 'Finnish' },
  { code: 'fj', nativeName: 'Vosa Vakaviti', name: 'Fijian' },
  { code: 'fo', nativeName: 'Føroyskt', name: 'Faroese' },
  { code: 'fr', nativeName: 'Français', name: 'French' },
  { code: 'fy', nativeName: 'Frysk', name: 'Western Frisian' },
  { code: 'ga', nativeName: 'Gaeilge', name: 'Irish' },
  { code: 'gd', nativeName: 'Gàidhlig', name: 'Scottish Gaelic' },
  { code: 'gl', nativeName: 'Galego', name: 'Galician' },
  { code: 'gn', nativeName: "Avañe'ẽ", name: 'Guaraní' },
  { code: 'gu', nativeName: 'ગુજરાતી', name: 'Gujarati' },
  { code: 'gv', nativeName: 'Gaelg', name: 'Manx' },
  { code: 'ha', nativeName: 'هَوُسَ', name: 'Hausa' },
  { code: 'he', nativeName: 'עברית', name: 'Hebrew' },
  { code: 'hi', nativeName: 'हिन्दी', name: 'Hindi' },
  { code: 'ho', nativeName: 'Hiri Motu', name: 'Hiri Motu' },
  { code: 'hr', nativeName: 'Hrvatski', name: 'Croatian' },
  { code: 'ht', nativeName: 'Kreyòl ayisyen', name: 'Haitian Creole' },
  { code: 'hu', nativeName: 'Magyar', name: 'Hungarian' },
  { code: 'hy', nativeName: 'Հայերեն', name: 'Armenian' },
  { code: 'hz', nativeName: 'Otjiherero', name: 'Herero' },
  { code: 'ia', nativeName: 'Interlingua', name: 'Interlingua' },
  { code: 'id', nativeName: 'Bahasa Indonesia', name: 'Indonesian' },
  { code: 'ie', nativeName: 'Interlingue', name: 'Interlingue' },
  { code: 'ig', nativeName: 'Asụsụ Igbo', name: 'Igbo' },
  { code: 'ii', nativeName: 'ꆈꌠꉙ', name: 'Sichuan Yi' },
  { code: 'ik', nativeName: 'Iñupiaq', name: 'Inupiaq' },
  { code: 'io', nativeName: 'Ido', name: 'Ido' },
  { code: 'is', nativeName: 'Íslenska', name: 'Icelandic' },
  { code: 'it', nativeName: 'Italiano', name: 'Italian' },
  { code: 'iu', nativeName: 'ᐃᓄᒃᑎᑐᑦ', name: 'Inuktitut' },
  { code: 'ja', nativeName: '日本語', name: 'Japanese' },
  { code: 'jv', nativeName: 'Basa Jawa', name: 'Javanese' },
  { code: 'ka', nativeName: 'ქართული', name: 'Georgian' },
  { code: 'kg', nativeName: 'Kikongo', name: 'Kongo' },
  { code: 'ki', nativeName: 'Gĩkũyũ', name: 'Kikuyu' },
  { code: 'kj', nativeName: 'Kuanyama', name: 'Kwanyama' },
  { code: 'kk', nativeName: 'Қазақ тілі', name: 'Kazakh' },
  { code: 'kl', nativeName: 'Kalaallisut', name: 'Kalaallisut' },
  { code: 'km', nativeName: 'ខ្មែរ', name: 'Khmer' },
  { code: 'kn', nativeName: 'ಕನ್ನಡ', name: 'Kannada' },
  { code: 'ko', nativeName: '한국어', name: 'Korean' },
  { code: 'kr', nativeName: 'Kanuri', name: 'Kanuri' },
  { code: 'ks', nativeName: 'कश्मीरी', name: 'Kashmiri' },
  { code: 'ku', nativeName: 'Kurdî', name: 'Kurdish' },
  { code: 'kv', nativeName: 'Коми кыв', name: 'Komi' },
  { code: 'kw', nativeName: 'Kernewek', name: 'Cornish' },
  { code: 'ky', nativeName: 'Кыргызча', name: 'Kyrgyz' },
  { code: 'la', nativeName: 'Latine', name: 'Latin' },
  { code: 'lb', nativeName: 'Lëtzebuergesch', name: 'Luxembourgish' },
  { code: 'lg', nativeName: 'Luganda', name: 'Ganda' },
  { code: 'li', nativeName: 'Limburgs', name: 'Limburgish' },
  { code: 'ln', nativeName: 'Lingála', name: 'Lingala' },
  { code: 'lo', nativeName: 'ລາວ', name: 'Lao' },
  { code: 'lt', nativeName: 'Lietuvių', name: 'Lithuanian' },
  { code: 'lu', nativeName: 'Tshiluba', name: 'Luba-Katanga' },
  { code: 'lv', nativeName: 'Latviešu', name: 'Latvian' },
  { code: 'mg', nativeName: 'Malagasy', name: 'Malagasy' },
  { code: 'mh', nativeName: 'Kajin M̧ajeļ', name: 'Marshallese' },
  { code: 'mi', nativeName: 'Te reo Māori', name: 'Māori' },
  { code: 'mk', nativeName: 'Македонски', name: 'Macedonian' },
  { code: 'ml', nativeName: 'മലയാളം', name: 'Malayalam' },
  { code: 'mn', nativeName: 'Монгол', name: 'Mongolian' },
  { code: 'mr', nativeName: 'मराठी', name: 'Marathi' },
  { code: 'ms', nativeName: 'Bahasa Melayu', name: 'Malay' },
  { code: 'mt', nativeName: 'Malti', name: 'Maltese' },
  { code: 'my', nativeName: 'မြန်မာဘာသာ', name: 'Burmese' },
  { code: 'na', nativeName: 'Dorerin Naoero', name: 'Nauru' },
  { code: 'nb', nativeName: 'Norsk Bokmål', name: 'Norwegian Bokmål' },
  { code: 'nd', nativeName: 'isiNdebele', name: 'North Ndebele' },
  { code: 'ne', nativeName: 'नेपाली', name: 'Nepali' },
  { code: 'ng', nativeName: 'Owambo', name: 'Ndonga' },
  { code: 'nl', nativeName: 'Nederlands', name: 'Dutch' },
  { code: 'nn', nativeName: 'Norsk Nynorsk', name: 'Norwegian Nynorsk' },
  { code: 'no', nativeName: 'Norsk', name: 'Norwegian' },
  { code: 'nr', nativeName: 'isiNdebele', name: 'South Ndebele' },
  { code: 'nv', nativeName: 'Diné bizaad', name: 'Navajo' },
  { code: 'ny', nativeName: 'Chichewa', name: 'Chichewa' },
  { code: 'oc', nativeName: 'Occitan', name: 'Occitan' },
  { code: 'oj', nativeName: 'ᐊᓂᔑᓈᐯᒧᐎᓐ', name: 'Ojibwe' },
  { code: 'om', nativeName: 'Afaan Oromoo', name: 'Oromo' },
  { code: 'or', nativeName: 'ଓଡ଼ିଆ', name: 'Odia' },
  { code: 'os', nativeName: 'Ирон æвзаг', name: 'Ossetian' },
  { code: 'pa', nativeName: 'ਪੰਜਾਬੀ', name: 'Punjabi' },
  { code: 'pi', nativeName: 'पाऴि', name: 'Pali' },
  { code: 'pl', nativeName: 'Polski', name: 'Polish' },
  { code: 'ps', nativeName: 'پښتو', name: 'Pashto' },
  { code: 'pt', nativeName: 'Português', name: 'Portuguese' },
  { code: 'qu', nativeName: 'Runa Simi', name: 'Quechua' },
  { code: 'rm', nativeName: 'Rumantsch', name: 'Romansh' },
  { code: 'rn', nativeName: 'Ikirundi', name: 'Kirundi' },
  { code: 'ro', nativeName: 'Română', name: 'Romanian' },
  { code: 'ru', nativeName: 'Русский', name: 'Russian' },
  { code: 'rw', nativeName: 'Ikinyarwanda', name: 'Kinyarwanda' },
  { code: 'sa', nativeName: 'संस्कृतम्', name: 'Sanskrit' },
  { code: 'sc', nativeName: 'Sardu', name: 'Sardinian' },
  { code: 'sd', nativeName: 'سنڌي', name: 'Sindhi' },
  { code: 'se', nativeName: 'Davvisámegiella', name: 'Northern Sami' },
  { code: 'sg', nativeName: 'Sängö', name: 'Sango' },
  { code: 'si', nativeName: 'සිංහල', name: 'Sinhala' },
  { code: 'sk', nativeName: 'Slovenčina', name: 'Slovak' },
  { code: 'sl', nativeName: 'Slovenščina', name: 'Slovenian' },
  { code: 'sm', nativeName: 'Gagana Samoa', name: 'Samoan' },
  { code: 'sn', nativeName: 'chiShona', name: 'Shona' },
  { code: 'so', nativeName: 'Soomaaliga', name: 'Somali' },
  { code: 'sq', nativeName: 'Shqip', name: 'Albanian' },
  { code: 'sr', nativeName: 'Српски', name: 'Serbian' },
  { code: 'ss', nativeName: 'SiSwati', name: 'Swati' },
  { code: 'st', nativeName: 'Sesotho', name: 'Southern Sotho' },
  { code: 'su', nativeName: 'Basa Sunda', name: 'Sundanese' },
  { code: 'sv', nativeName: 'Svenska', name: 'Swedish' },
  { code: 'sw', nativeName: 'Kiswahili', name: 'Swahili' },
  { code: 'ta', nativeName: 'தமிழ்', name: 'Tamil' },
  { code: 'te', nativeName: 'తెలుగు', name: 'Telugu' },
  { code: 'tg', nativeName: 'Тоҷикӣ', name: 'Tajik' },
  { code: 'th', nativeName: 'ภาษาไทย', name: 'Thai' },
  { code: 'ti', nativeName: 'ትግርኛ', name: 'Tigrinya' },
  { code: 'tk', nativeName: 'Türkmençe', name: 'Turkmen' },
  { code: 'tl', nativeName: 'Filipino', name: 'Filipino' },
  { code: 'tn', nativeName: 'Setswana', name: 'Tswana' },
  { code: 'to', nativeName: 'Faka Tonga', name: 'Tonga' },
  { code: 'tr', nativeName: 'Türkçe', name: 'Turkish' },
  { code: 'ts', nativeName: 'Xitsonga', name: 'Tsonga' },
  { code: 'tt', nativeName: 'Татар теле', name: 'Tatar' },
  { code: 'tw', nativeName: 'Twi', name: 'Twi' },
  { code: 'ty', nativeName: 'Reo Tahiti', name: 'Tahitian' },
  { code: 'ug', nativeName: 'ئۇيغۇرچە', name: 'Uyghur' },
  { code: 'uk', nativeName: 'Українська', name: 'Ukrainian' },
  { code: 'ur', nativeName: 'اردو', name: 'Urdu' },
  { code: 'uz', nativeName: 'Oʻzbek', name: 'Uzbek' },
  { code: 've', nativeName: 'Tshivenḓa', name: 'Venda' },
  { code: 'vi', nativeName: 'Tiếng Việt', name: 'Vietnamese' },
  { code: 'vo', nativeName: 'Volapük', name: 'Volapük' },
  { code: 'wa', nativeName: 'Walon', name: 'Walloon' },
  { code: 'wo', nativeName: 'Wollof', name: 'Wolof' },
  { code: 'xh', nativeName: 'isiXhosa', name: 'Xhosa' },
  { code: 'yi', nativeName: 'ייִדיש', name: 'Yiddish' },
  { code: 'yo', nativeName: 'Yorùbá', name: 'Yoruba' },
  { code: 'za', nativeName: 'Saɯ cueŋƅ', name: 'Zhuang' },
  { code: 'zh', nativeName: '中文', name: 'Chinese' },
  { code: 'zu', nativeName: 'isiZulu', name: 'Zulu' },
]

export default ISO_639_1_LANGUAGES
